import * as Yup from "yup";
import {
  FAX_NUMBER_LENGTH_MESSAGE,
  FAX_NUMBER_PATTERN,
  HAS_LETTER_REGEX,
  INVALID_NAME_MESSAGE,
} from "@/constants/validation-constant";

export const PREFERENCE_DRAWER_TITLE = "Add New Preferences";
export const PREFERENCE_SUBMIT_LABEL = "Save Preferences";

export const PREFERENCE_VALIDATION_SCHEMA = Yup.object({
  preferenceType: Yup.string().required().label("Preference Type"),
  name: Yup.string().when("preferenceType", (preferenceType, schema) => {
    const dynamicLabel =
      preferenceType.toLocaleString() === "LAB"
        ? "Lab Name"
        : preferenceType.toLocaleString() === "PHARMACY"
          ? "Pharmacy Name"
          : preferenceType.toLocaleString() === "RADIOLOGY"
            ? "Radiology Name"
            : "Name";

    return schema
      .trim()
      .required()
      .matches(HAS_LETTER_REGEX, INVALID_NAME_MESSAGE)
      .label(dynamicLabel);
  }),
  contactNumber: Yup.string().min(
    12,
    "Contact Number must be at least 8 digits"
  ),
  faxNumber: Yup.string().matches(FAX_NUMBER_PATTERN, {
    message: FAX_NUMBER_LENGTH_MESSAGE,
    excludeEmptyString: true,
  }),
});
